"use strict";
module.exports = {
    'v1.copackAgreement.upsert': 'settlement',
    'v1.copackAgreement.upsertWhenEmpty': 'settlement',
    'v1.copackAgreement.updateWhenEmpty': 'settlement',
    'v1.copackAgreement.update': 'settlement',
    'v1.orderBrokerageAgreement.upsert': 'settlement',
    'v1.orderBrokerageAgreement.upsertWhenEmpty': 'settlement',
    'v1.orderBrokerageAgreement.updateWhenEmpty': 'settlement',
    'v1.orderBrokerageAgreement.update': 'settlement',
    'v1.entitySettlement.upsertManualEntitySettlement': 'settlement',
    'v1.entitySettlement.createEntitySettlementFromOrderCorrection': 'settlement',
    'v1.entitySettlement.cancel': 'settlement',
    'v1.entitySettlement.ensureBasedOnOrder': 'settlement',
    'v1.entitySettlement.ensureBasedOnComplaint': 'settlement',
    'v1.entitySettlement.ensureBasedOnPurchaseOrder': 'settlement',
    'v1.entitySettlement.upsert': 'settlement',
    'v1.entitySettlement.upsertWhenEmpty': 'settlement',
    'v1.entitySettlement.updateWhenEmpty': 'settlement',
    'v1.entitySettlement.update': 'settlement',
    'v1.settlement.createForPeriod': 'settlement',
    'v1.settlement.sendToSupplierOrganization': 'settlement',
    'v1.settlement.receiveInvoiceFromSupplierOrganization': 'settlement',
    'v1.settlement.markInvoiceAsDone': 'settlement',
    'v1.settlement.resendReport': 'settlement',
    'v1.settlement.setReceiver': 'settlement',
    'v1.settlement.cancel': 'settlement',
    'v1.settlement.addToReport': 'settlement',
    'v1.settlement.removeFromReport': 'settlement',
    'v1.settlement.sendToExternalFortnox': 'settlement',
    'v1.settlement.upsert': 'settlement',
    'v1.settlement.upsertWhenEmpty': 'settlement',
    'v1.settlement.updateWhenEmpty': 'settlement',
    'v1.settlement.update': 'settlement',
    'v1.settlementEventsource.cleanUpOldEvents': 'settlement',
    'v1.settlementEventsource.undoEvent': 'settlement',
    'v1.settlementEventsource.reEmit': 'settlement',
};
